import Rails from "@rails/ujs";
import "bootstrap";
import "../scripts/nav_height";
Rails.start();